<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<div class="table-container">
  <div id="header-container" class="d-flex justify-content-end gap-3 mt-1 mb-3">
    <div class="">
      <div class="search-container">
        <input type="text" class="form-control search_input" style="font-size: 13px;" placeholder="Search"
          [(ngModel)]="searchValue">
      </div>
    </div>

    <div class="">
      <div class="d-flex gap-2 action-buttons-container">
        <div *ngIf="data =='Created'" class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="openAddPopup()" (keydown.enter)="openAddPopup()" matTooltip="Add Event">
          <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
          <span class="reload_text text-white">Add New</span>
        </div>
        <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="refreshGrid()"
          (keydown.enter)="refreshGrid()" matTooltip="Refresh Grid">
          <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
          <span class="reload_text">Reload</span>
        </div>
      </div>
    </div>
  </div>

  <table class="dynamic-table-container documentTable">
    <th style="min-width: 60px;max-width: 60px; text-align: center;">
    </th>
    <th *ngFor="let column of columnList"
      [ngStyle]="{'min-width': column.width, 'max-width': column.width, 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
        <span>{{column.column}}</span>
        <div class="d-flex gap-2 align-items-center">
          <div>
            <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
          </div>
        </div>
      </div>
    </th>

    <tr *ngFor="let event of eventsList | searchFilter : searchValue; let idx = index;">
      <td style="width: 60px; text-align: center;"
        [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
        <div style="display: flex;">
          <div [ngClass]="event.childCheckBoxs ?'static_icon':'hover-menu-icons'">
            <i class="fa-solid fa-ellipsis-vertical"></i>
          </div>
          <div>
            <input type="checkbox" style="zoom: 1.2;" [checked]="event.childCheckBoxs"
              (change)="dataGridChildCheckBoxChecked($event, event, idx)">
          </div>
        </div>
      </td>
      <td class="grid-row-container" style="text-align: center;overflow: hidden;text-overflow: 'ellipsis';
        white-space: 'nowrap'"><span>{{event.eventName}}</span></td>
      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
         white-space: 'nowrap'"><span>{{event.eventDetails}}</span></td>
      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
          white-space: 'nowrap'"><span>{{event.eventStartDate}}</span></td>
      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
           white-space: 'nowrap'"><span>{{event.eventEndDate}}</span></td>
      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
           white-space: 'nowrap'"><span>{{event.involvedUserNames}}</span></td>
      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
           white-space: 'nowrap'"><span>{{event.createdOn}}</span></td>
      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
           white-space: 'nowrap'"><span>{{event.createdByUser}}</span></td>
      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
             white-space: 'nowrap'"><span>{{event.updatedOn}}</span></td>
      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
             white-space: 'nowrap'"><span>{{event.updatedByUser}}</span></td>
      <td class="sticky-col first-col" *ngIf="data =='Created'">
        <div class="action-icons">
          <i class="fa-solid fa-pencil" matTooltip="Edit Event" style="margin-left: 5px;"
            (click)="openEditPopup(event,$event)" (keydown.enter)="openEditPopup(event,$event)"></i>
          <i class="fa-sharp fa-solid fa-trash" title="Delete" style="margin-left: 5px;"
            (click)="openDeletePopup(event,$event)" (keydown.enter)="openDeletePopup(event,$event)"></i>

        </div>
      </td>
    </tr>
  </table>
  <div class="d-flex justify-content-center">
    <div class="width-cheat small paginationCell">
      <div class="d-flex align-items-center gap-3">
        <div class="pagination_text mt-3">
          {{ showingRowsText }}
          1-{{ perPage }} of {{ collectionSize | number }}
        </div>
        <div>
          <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
            [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
            [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
          </ngb-pagination>
        </div>
        <div ngbDropdown class="mt-3">
          <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic1" ngbDropdownToggle>
            {{ perPage }}
            <i class="ms-1 fa-solid fa-chevron-down"></i>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
            <button ngbDropdownItem (click)="paginationCall(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall(50)">50</button>
          </div>
          per page
        </div>
      </div>
    </div>
  </div>

</div>

<ng-template #deleteEventPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <h2 mat-dialog-title>{{title }}</h2>
  <div style="margin: 15px 15px;">
    <div class="form-continer">
      <div class="row">
        <div class="col-md-12">
          <div><label for="deleteReason"> Reason</label><span class="mandatory-symbol">*</span></div>
          <textarea id="deleteReason" rows="6" class="textarea-filed-continers" type="text"
            [(ngModel)]="eventData.deleteReason"></textarea>
          <span id="deleteReason-required-msg">Please enter reason for delete</span>
        </div>
      </div>
      <br>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="deleteButton" (click)="deleteFunction()">
        <i class="fa fa-trash"></i> Delete
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelDeleteFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>
<ng-template #searchUser>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelSearchUserFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupTitle }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div id="filed-container" class="form-continer">
    <div class="row">
      <div class="col-md-3">
        <div><label for="email ">User Name</label></div>
        <input class="search-filed-continers uppercase" type="text" placeholder="Enter User Name"
          [(ngModel)]="searchByUserName">
        <div id="searchbyUserName-val-icon" class="field-icon-container"></div>
      </div>
      <div class="col-md-3">
        <div><label for="email">First Name</label></div>
        <input class="search-filed-continers" type="text" placeholder="Enter First Name"
          [(ngModel)]="searchByFirstName">
        <div id="firstName-val-icon" class="field-icon-container"></div>
      </div>
      <div class="col-md-3">
        <div><label for="email">Last Name</label></div>
        <input class="search-filed-continers" type="text" placeholder="Enter Last Name" [(ngModel)]="searchByLastName">
        <div id="lastName-val-icon" class="field-icon-container"></div>
      </div>
      <div class="col-md-3">
        <div><label for="email">Designation</label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="searchByDesignationCode"
          (closed)="designationSearchText=''" (click)="focusSearch('focus-designation-search')"
          (keydown.enter)="focusSearch('focus-designation-search')">
          <input type="search" id="focus-designation-search" class="dropdownsearchstyle"
            [(ngModel)]="designationSearchText" matInput placeholder="search">
          <mat-option class="unselectStyle" [value]="null"
            (onSelectionChange)="onDesignationCodeSelect(null)">Un-select</mat-option>
          <mat-option *ngFor="let item of designationCodeDropdown | assessmentSearch : designationSearchText"
            [value]="item.valueExp" (onSelectionChange)="onDesignationCodeSelect(item)">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>

    </div>
    <div class="row">
      <div class="col-md-3">
        <div><label for="email">Department</label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="searchByDepartmentCode"
          (closed)="departmentSearchText=''" (click)="focusSearch('focus-department-search')"
          (keydown.enter)="focusSearch('focus-department-search')">
          <input type="search" id="focus-department-search" class="dropdownsearchstyle"
            [(ngModel)]="departmentSearchText" matInput placeholder="search">
          <mat-option class="unselectStyle" [value]="null"
            (onSelectionChange)="onDepartmentCodeSelect(null)">Un-select</mat-option>
          <mat-option *ngFor="let item of departmentCodeDropdown | assessmentSearch : departmentSearchText"
            [value]="item.valueExp" (onSelectionChange)="onDepartmentCodeSelect(item)">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="row fieldstyle">
      <div class="search-button-continer btn-align" mat-dialog-actions>
        <button mat-stroked-button class="searchButton" (click)="searchUserGridDataFunction()">
          <i class="fa-solid fa-magnifying-glass"></i> Search
        </button>
        <button mat-stroked-button class="cancelButton" (click)="resetSearchUserGridDataFunction()">
          <i class="fa fa-repeat"></i> Reset
        </button>
      </div>
    </div>
    <div class="table-container" *ngIf="showUserSearchGrid">
      <table class="search-manager-table-container">
        <th style="min-width: 80px; text-align: center;">
          <div style="display: flex;">
            <div>
              <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
            </div>
            <div style="margin-left: 5px;">
              <input type="checkbox" style="zoom: 1.2;" [checked]="searchUserParentCheckBox"
                (change)="searchUserDataGridParentCheckBoxChecked($event)">
            </div>
          </div>
        </th>
        <th> <span>User Name</span> <span class="fa-solid fa-filter multi-filter-container"></span> </th>
        <th> <span>First Name</span> <span class="fa-solid fa-filter multi-filter-container"></span> </th>
        <th> <span>Last Name</span> <span class="fa-solid fa-filter multi-filter-container"></span> </th>
        <th> <span>User Full Name</span> <span class="fa-solid fa-filter multi-filter-container"></span> </th>
        <th> <span>Designation</span> <span class="fa-solid fa-filter multi-filter-container"></span> </th>
        <th> <span>Department</span> <span class="fa-solid fa-filter multi-filter-container"></span> </th>
        <th> <span>EmailAddress</span> <span class="fa-solid fa-filter multi-filter-container"></span> </th>
        <th> <span>Manager Name</span> <span class="fa-solid fa-filter multi-filter-container"></span> </th>
        <th id="menu" class="sticky-col first-col"></th>
        <tr class="data-row-container"
          *ngFor="let listOfUsersVwDetails of getOneQmsUsersVwDetailsTableData; let idx = index;">
          <td style="min-width: 80px; text-align: center;">
            <div style="display: flex;">
              <div [ngClass]="listOfUsersVwDetails.searchUserChildCheckBoxs ?'static_icon':'hover-menu-icons'">
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </div>
              <div style="margin-left: 5px;">
                <input id="selectedUserCheckBox" type="checkbox" style="zoom: 1.2;"
                  [checked]="listOfUsersVwDetails.searchUserChildCheckBoxs"
                  (change)="searchUserChildCheckBoxChecked($event, listOfUsersVwDetails, idx)">
              </div>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersVwDetails.userName }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.firstName }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.lastName }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.userFullname }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.designation }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.department }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.emailAddress }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.managerName }}</td>
        </tr>
      </table>
    </div>
  </div>
  <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="addUserNameFunction()"
      (keydown.enter)="addUserNameFunction()">
      <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
      <span class="reload_text text-white">Add</span>
    </div>
    <button mat-stroked-button class="cancelButton" (click)="cancelSearchUserFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<ng-template #addEventPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelEventFunction()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>

    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{title}}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="form-continer filed-container">
      <div class="row">
        <div class="col-md-6">
          <div><label for="contentName">Event Name</label><span class="mandatory-symbol">*</span></div>
          <input id="contentName" class="input-filed-continers" type="text" [(ngModel)]="eventData.eventName"
            (blur)="validateField('eventName')"
            [ngClass]="{'error-border': !eventData.eventName && isSubmitted, 'valid-border': eventData.eventName}">
        </div>
        <div class="col-md-6">
          <div><label for="totalDuration">Involved Users</label></div>
          <div class="dms-search-container">
            <input id="userName" class="form-control" type="text" placeholder="Users"
              [(ngModel)]="eventData.involvedUserNames" (click)="searchUserFunction()" />
          </div>
        </div>

      </div>
      <div class="row">
        <div class="col-md-4">
          <div><label for="waitTime">Notify Before N Days</label></div>
          <input id="waitTime" class="input-filed-continers" type="number" min="0"
            [(ngModel)]="eventData.notifyBeforeNDays">
        </div>
        <div class="col-md-4">
          <div><label for="email">Event Start Date:</label></div>
          <div>
            <input type="text" class="form-control data-picker-continer" bsDatepicker
              [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
              [(ngModel)]="eventData.eventStartDate" [minDate]="todayDate" />
          </div>
        </div>
        <div class="col-md-4">
          <div><label for="eventEndDate">Event End Date:</label><span class="mandatory-symbol">*</span></div>
          <input type="text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="datePickerConfiguration"
            [(ngModel)]="eventData.eventEndDate" (blur)="validateField('eventEndDate')"
            [ngClass]="{'error-border': !eventData.eventEndDate && isSubmitted, 'valid-border': eventData.eventEndDate}">
        </div>

      </div>
      <div class="row">
        <div class="col-md-12">
          <div><label for="description">Event Details</label><span class="mandatory-symbol">*</span></div>
          <textarea id="description" class="textarea-filed-continers" rows="4" cols="50"
            [(ngModel)]="eventData.eventDetails" (blur)="validateField('eventDetails')"
            [ngClass]="{'error-border': !eventData.eventDetails && isSubmitted, 'valid-border': eventData.eventDetails}">
            </textarea>
        </div>
      </div>
      <br>
      <br>
      <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="addEventFunction(eventData)" (keydown.enter)="addEventFunction(eventData)">
          <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
          <span class="reload_text text-white">Add New</span>
        </div>
        <button mat-stroked-button class="cancelButton" (click)="cancelEventFunction()">
          <i class="fa fa-close"></i> Cancel
        </button>
      </div>
    </div>

  </div>
</ng-template>
